import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useToast } from "../components/ui/use-toast";
import { fetch } from "./fetch";

const updateBookingGoodToKnow = async (bookingId: string, goodToKnow: string) => {
  return fetch(`/api/bookings/${bookingId}/good-to-know`, "PATCH", { goodToKnow });
};

export const useBookingGoodToKnowMutation = (bookingId: string) => {
  const queryClient = useQueryClient();
  const { toast, dismiss } = useToast();

  return useMutation({
    mutationFn: (data: { goodToKnow: string; toastId: any }) => updateBookingGoodToKnow(bookingId, data.goodToKnow),
    onSuccess: (_, variables) => {
      dismiss(variables.toastId);

      toast({
        title: "Success",
        description: "Good to know section updated successfully!",
        variant: "default",
      });

      queryClient.invalidateQueries({ queryKey: ["bookingYachtOfferData", bookingId] });
    },
    onError: (error: any, variables) => {
      dismiss(variables.toastId);
      toast({
        title: "Error",
        description: error.message || "Failed to update good to know section!",
        variant: "destructive",
      });
    },
  });
};
